import React, { useEffect, useState } from "react";
import {
  HStack,
  IconButton,
  Box,
  Heading,
  Text,
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepStatus,
  StepTitle,
  Stepper,
  useSteps,
  Stack,
  useToast,
} from "@chakra-ui/react";
import { MdArrowBack } from "react-icons/md";
import { Formik, Form } from "formik";
import { useNavigate } from "react-router-dom";
import { getEtapas, getPlanificaciones } from "../../../helpers/api.helper";
import PrimerPasoEtapa from "./PrimerPasoEtapa";
import SegundoPasoEtapa from "./SegundoPasoEtapa";
import TercerPasoEtapa from "./TercerPasoEtapa";
import CuartoPasoEtapa from "./CuartoPasoEtapa";
import { useSelector } from "react-redux";
import { crearEtapa, editarEtapa } from "../../../helpers/api.helper";
import moment from "moment";
import { getUsuarios } from "../../../../usuarios/helpers/api.helper";
import { validateOnSubmit } from "../../../../../utils/Validaciones";
import { CONSTANTS } from "../../../../../utils/dictionary";
import { tnsToLbs } from "../../../../../utils/handleWeightConversion";

const CrearEditarEtapas = (props) => {
  const {
    type,
    seleccionado,
    onClose,
    initTablaEtapas,
    operacionSeleccionada,
  } = props;
  const [planificacion, setPlanificacion] = useState([]);
  const [loading, setLoading] = useState(true);
  const [etapasDatos, setEtapasDatos] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [sandcubesVaciar, setSancubesVaciar] = useState([]);
  const [sandCubesPlanificacion, setSandCubesPlanificacion] = useState([]);
  const [seleccionados, setSeleccionados] = useState(
    type === "editar" && seleccionado.sandCubes ? seleccionado.sandCubes : []
  );
  const [vacios, setVacios] = useState([]);
  const [showButton, setShowButton] = useState(false);
  const [formValues, setFormValues] = useState({
    initialValues:
      type === "editar"
        ? {
            idPozoEtapa: seleccionado.pozo.nombrePozo,
            fechaInicioEtapaSC: moment(seleccionado.fechaInicioEtapaSC).format(
              "YYYY-MM-DD HH:mm"
            ),
            fechaFinalEtapaSC: seleccionado.fechaFinalEtapaSC,
            numPozoEtapaSC: seleccionado.numPozoEtapaSC,
            numTotalEtapaSC: seleccionado.numTotalEtapaSC,
            supervisor: seleccionado.supervisor,
            operador1: seleccionado.operador1,
            operador2: seleccionado.operador2,
            maquinista: seleccionado.maquinista,
            idSander: seleccionado.sander?.idSander,
            idAutoE: seleccionado.autoelevador?.idAutoE,
            etapaWeTSanD: seleccionado.etapaWeTSanD,
            sandcubesEtapa: seleccionado.sandCubes,
            limpieza: seleccionado.limpieza,
            observacionesESC: seleccionado.observacionesESC || "",
            idTipoOperacion: seleccionado.idTipoOperacion,
            consumidoSC: seleccionado.consumidoSC || 0,
            consumidoGranel:
              tnsToLbs(seleccionado.consumidoGranel).toFixed(2) || 0,
            consumidoTotal: seleccionado.consumidoTotal || 0,
          }
        : {
            idPozoEtapa: "",
            fechaInicioEtapaSC: moment().format("YYYY-MM-DD HH:mm"),
            fechaFinalEtapaSC: moment().format("YYYY-MM-DD HH:mm"),
            numPozoEtapaSC: "",
            numTotalEtapaSC: "",
            supervisor: "",
            operador1: "",
            operador2: "",
            maquinista: "",
            idSander: undefined,
            idAutoE: undefined,
            etapaWeTSanD: false,
            sandcubesEtapa: [],
            limpieza: false,
            observacionesESC: "",
            idTipoOperacion: undefined,
            consumidoSC: 0,
            consumidoGranel: 0,
            consumidoTotal: 0,
          },
  });
  const [text, setText] = useState("");
  const navigate = useNavigate();
  const toast = useToast();
  const { user } = useSelector((state) => state.user);
  const padLocacion =
    seleccionado?.padLocacion || operacionSeleccionada?.idPadlocacion;
  const steps = [
    { title: "Detalles etapa" },
    { title: "Seleccion de sandcubes para fractura" },
    { title: "Vaciado de Sandcubes" },
    { title: "Cierre de etapa" },
  ];
  const { activeStep, setActiveStep } = useSteps({
    index: 0,
    count: steps.length,
  });

  const initDataPlanificaciones = async () => {
    setLoading(true);
    try {
      const res = await getPlanificaciones({ padLocacion });
      setPlanificacion(res.data[0]);
    } catch (error) {
      return toast({
        title: "Error",
        description: "Error al cargar datos Planificaciones",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const initDataUsuarios = async () => {
    setLoading(true);
    try {
      const res = await getUsuarios();

      if (res.status === 200) {
        setUsuarios(res.data);
      }
    } catch (error) {
      return toast({
        title: "Error",
        description: " Error al cargar datos Usuarios",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const initDataEtapas = async () => {
    setLoading(true);
    try {
      let res = await getEtapas({ ultimo: true, padLocacion });
      setEtapasDatos(res.data);
      if (type === "crear") {
        let a;
        if (res.status === 200) {
          if (!res.data || res.data.length === 0) {
            return null;
          }

          a = res.data.maxNumTotalEtapaSC + 1;
        } else if (res.status === 204) {
          a = 1;
        }
        setFormValues((prev) => ({
          initialValues: {
            ...prev.initialValues,
            numTotalEtapaSC: a,
          },
        }));
      }
    } catch (error) {
      return toast({
        title: "Error",
        description: "Error al cargar datos Etapas",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    initDataPlanificaciones();
    initDataUsuarios();
    initDataEtapas();
  }, []);

  return (
    <Stack w="100%" h="100%" overflow={"auto"}>
      <HStack pl={5} w="100%" bg="brand.fondos_secundario">
        <Box>
          {type === "crear" && (
            <IconButton
              icon={<MdArrowBack />}
              variant="link"
              onClick={() => navigate(-1)}
              fontSize="24px"
            />
          )}
        </Box>
        <Heading
          fontWeight="medium"
          size="xl"
          fontFamily="fonts.title"
          color="brand.gris_primario"
        >
          Nueva etapa
        </Heading>
        <Text fontSize="16px" placeSelf="end" letterSpacing={1}>
          de {planificacion.idPadlocacion}
        </Text>
      </HStack>
      {planificacion && (
        <>
          <HStack w="100%" px={3} justifyContent="space-between">
            <Stepper index={activeStep} colorScheme="orange">
              {steps.map((step, index) => (
                <Step key={step * 2 + index}>
                  <StepIndicator>
                    <StepStatus
                      complete={<StepIcon />}
                      incomplete={<StepNumber />}
                      active={<StepNumber />}
                    />
                  </StepIndicator>

                  <Box flexShrink="1">
                    <StepTitle>{step.title}</StepTitle>
                  </Box>
                </Step>
              ))}
            </Stepper>
            <Text color="brand.azul_text" fontSize={14}>
              {activeStep + 1} de {steps.length} partes
            </Text>
          </HStack>
          {!loading && (
            <Formik
              initialValues={formValues.initialValues}
              enableReinitialize={true}
              onSubmit={async (values) => {
                setLoading(true);
                if (
                  moment(values.fechaInicioEtapaSC).isAfter(
                    values.fechaFinalEtapaSC
                  )
                ) {
                  setLoading(false);
                  return toast({
                    title: "Error",
                    description:
                      "La fecha final debe ser posterior a la inicial",
                    status: "error",
                    isClosable: true,
                    duration: 3000,
                  });
                }
                if (validateOnSubmit("textArea", values.observacionesESC)) {
                  setLoading(false);
                  return toast({
                    title: "Error",
                    description:
                      "Los caracteres de la observacion no estan permitidos",
                    status: "error",
                    isClosable: true,
                    duration: 3000,
                  });
                }
                if (
                  (!values.consumidoSC &&
                    values.idTipoOperacion !==
                      CONSTANTS.TIPO_OPERACION.A_GRANEL.ID) ||
                  validateOnSubmit("decimal", values.consumidoSC)
                ) {
                  setLoading(false);
                  return toast({
                    title: "Error",
                    description:
                      "El campo 'Consumido en SandCubes' es obligatorio.",
                    status: "error",
                    isClosable: true,
                    duration: 3000,
                  });
                }
                if (
                  (!values.consumidoGranel &&
                    values.idTipoOperacion !==
                      CONSTANTS.TIPO_OPERACION.SANDCUBES.ID) ||
                  validateOnSubmit("decimal", values.consumidoGranel)
                ) {
                  setLoading(false);
                  return toast({
                    title: "Error",
                    description:
                      "El campo 'Consumido en Granel' es obligatorio.",
                    status: "error",
                    isClosable: true,
                    duration: 3000,
                  });
                }

                let z = planificacion.pozos.find(
                  (pozo) => pozo.nombrePozo === values.idPozoEtapa
                );
                let sandcubes = [...sandcubesVaciar];
                let data =
                  type === "editar"
                    ? {
                        idPlanificacion: planificacion.idPlanificacion,
                        idPozo: z.idPozo,
                        id: seleccionado.idEtapaSC,
                        numPozoEtapaSC: values.limpieza
                          ? 0
                          : values.numPozoEtapaSC,
                        numTotalEtapaSC: values.limpieza
                          ? 0
                          : values.numTotalEtapaSC,
                        fechaInicioEtapaSC: moment(
                          values.fechaInicioEtapaSC
                        ).format("YYYY-MM-DD HH:mm"),
                        fechaFinalEtapaSC: moment(
                          values.fechaFinalEtapaSC
                        ).format("YYYY-MM-DD HH:mm"),
                        supervisor: values.supervisor,
                        maquinista: values.maquinista,
                        operador1: values.operador1,
                        operador2: values.operador2,
                        idSander: values.idSander,
                        idAutoE: values.idAutoE,
                        etapaWeTSanD: values.etapaWeTSanD,
                        sandcubes,
                        limpieza: values.limpieza,
                        observacionesESC: values.observacionesESC || "",
                        idTipoOperacion: values.idTipoOperacion,
                        consumidoSC:
                          values.idTipoOperacion ===
                          CONSTANTS.TIPO_OPERACION.A_GRANEL.ID
                            ? 0
                            : values.consumidoSC,
                        consumidoGranel: values.consumidoGranel || 0,
                        consumidoTotal: values.consumidoTotal,
                      }
                    : {
                        idPlanificacion: planificacion.idPlanificacion,
                        idPozo: z.idPozo,
                        numPozoEtapaSC: values.limpieza
                          ? 0
                          : values.numPozoEtapaSC,
                        numTotalEtapaSC: values.limpieza
                          ? 0
                          : values.numTotalEtapaSC,
                        fechaInicioEtapaSC: values.fechaInicioEtapaSC,
                        fechaFinalEtapaSC: values.fechaFinalEtapaSC,
                        supervisor: values.supervisor,
                        maquinista: values.maquinista,
                        operador1: values.operador1,
                        operador2: values.operador2,
                        idSander: values.idSander,
                        idAutoE: values.idAutoE,
                        etapaWeTSanD: values.etapaWeTSanD,
                        sandcubes,
                        limpieza: values.limpieza,
                        observacionesESC: values.observacionesESC,
                        idTipoOperacion: values.idTipoOperacion,
                        consumidoSC: values.consumidoSC || 0,
                        consumidoGranel: values.consumidoGranel || 0,
                        consumidoTotal: values.consumidoTotal,
                      };
                console.log("data", data);
                let res;

                if (type === "editar") {
                  res = await editarEtapa(data);
                } else {
                  res = await crearEtapa(data);
                }
                if (res.status === 200) {
                  toast({
                    status: "success",
                    isClosable: true,
                    title: `Etapa ${
                      type === "editar" ? "editada" : "creada"
                    } correctamente`,
                    duration: 3000,
                  });
                } else if (res.status === 204) {
                  toast({
                    status: "success",
                    isClosable: true,
                    title: `Etapa ${
                      type === "editar" ? "editada" : "creada"
                    } correctamente`,
                    duration: 3000,
                  });
                  toast({
                    status: "warning",
                    isClosable: true,
                    title: `No hay usuarios activos para notificar`,
                    duration: 3000,
                  });
                } else if (res.status === 403) {
                  setLoading(false);
                  return toast({
                    status: "error",
                    isClosable: true,
                    title: `Error al ${
                      type === "editar" ? "editar" : "crear"
                    } etapa, el numero de etapa ya existe`,
                    duration: 3000,
                  });
                } else {
                  setLoading(false);
                  return toast({
                    status: "error",
                    isClosable: true,
                    title: `Error al ${
                      type === "editar" ? "editar" : "crear"
                    } etapa`,
                    duration: 3000,
                  });
                }

                if (type === "editar") {
                  onClose();
                  initTablaEtapas();
                } else {
                  navigate(-1);
                }
                setLoading(false);
              }}
            >
              {({
                values,
                handleChange,
                handleBlur,
                setFieldValue,
                handleSubmit,
                touched,
                errors,
              }) => (
                <Stack w="100%">
                  <Form id="FormularioEtapa">
                    {activeStep === 0 && (
                      <PrimerPasoEtapa
                        activeStep={activeStep}
                        setActiveStep={setActiveStep}
                        values={values}
                        planificacion={planificacion}
                        type={type}
                        user={user}
                        etapasDatos={etapasDatos}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        setFormValues={setFormValues}
                        usuarios={usuarios}
                        touched={touched}
                        errors={errors}
                      />
                    )}
                    {activeStep === 1 && (
                      <SegundoPasoEtapa
                        activeStep={activeStep}
                        setActiveStep={setActiveStep}
                        type={type}
                        user={user}
                        setSancubesVaciar={setSancubesVaciar}
                        values={values}
                        seleccionados={seleccionados}
                        setSeleccionados={setSeleccionados}
                        planificacion={planificacion}
                        sandCubesPlanificacion={sandCubesPlanificacion}
                        setSandCubesPlanificacion={setSandCubesPlanificacion}
                      />
                    )}
                    {activeStep === 2 && (
                      <TercerPasoEtapa
                        activeStep={activeStep}
                        setActiveStep={setActiveStep}
                        type={type}
                        sandcubesVaciar={sandcubesVaciar}
                        setSancubesVaciar={setSancubesVaciar}
                        setVacios={setVacios}
                        vacios={vacios}
                        user={user}
                        showButton={showButton}
                        setShowButton={setShowButton}
                        planificacion={planificacion}
                        values={values}
                      />
                    )}
                    {activeStep === 3 && (
                      <CuartoPasoEtapa
                        activeStep={activeStep}
                        setActiveStep={setActiveStep}
                        values={values}
                        type={type}
                        user={user}
                        loading={loading}
                        onClose={onClose}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        setSandcubesVaciar={setSancubesVaciar}
                        planificacion={planificacion}
                        text={text}
                        handleSubmit={handleSubmit}
                        setText={setText}
                        errors={errors}
                        touched={touched}
                      />
                    )}
                  </Form>
                </Stack>
              )}
            </Formik>
          )}
        </>
      )}
      {planificacion.length < 1 && <></>}
    </Stack>
  );
};

export default CrearEditarEtapas;
